import Link from "next/link";
import ArrowIcon from "../icons/ArrowIcon";
import { useRouter } from "next/router";
import { Fragment } from "react";
import { useClient } from "@/hooks/useClient";

const BreadCrumb = ({ items }) => {
  const { locale } = useRouter();
  const { isClient } = useClient();

  return (
    <section className="py-2.5 sm:py-3 bg-[#F9F9F9]">
      <div className="flex items-center w-11/12 gap-1.5 sm:gap-3 mx-auto">
        <Link key={"home"} href="/" className="text-xs font-bold sm:text-sm">
          {locale === "ar" ? "الرئيسية" : "Home"}
        </Link>

        {items
          ?.filter((item) => item?.active === false)
          .map((item, i) => (
            <Fragment key={i}>
              <ArrowIcon
                className={`size-2.5 sm:size-3 ${
                  locale === "ar" ? "rotate-180" : ""
                }`}
              />
              <Link
                href={item?.url}
                className="text-xs font-bold min-w-fit line-clamp-1 sm:text-sm"
              >
                {item?.name}
              </Link>
            </Fragment>
          ))}

        {isClient && items
          ?.filter((item) => item?.active === true)
          .map((item, i) => (
            <Fragment key={i}>
              <ArrowIcon
                className={`size-2.5 sm:size-3 ${
                  locale === "ar" ? "rotate-180" : ""
                }`}
              />
              <span className="text-xs font-bold line-clamp-1 sm:text-sm">
                {item?.name}
              </span>
            </Fragment>
          ))}
      </div>
    </section>
  );
};

export default BreadCrumb;
